'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _checkbox = require('antd/lib/checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _connectField = require('uniforms/connectField');

var _connectField2 = _interopRequireDefault(_connectField);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _wrapField = require('./wrapField');

var _wrapField2 = _interopRequireDefault(_wrapField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderCheckboxes = function renderCheckboxes(props) {
    return props.fieldType === Array ? _react2.default.createElement(_checkbox2.default.Group, (0, _extends3.default)({
        disabled: props.disabled,
        id: props.id,
        name: props.name,
        onChange: function onChange(value) {
            return props.onChange(value);
        },
        options: props.allowedValues.map(String),
        value: props.value.map(String).map(props.transform || String)
    }, (0, _filterDOMProps2.default)(props))) : _react2.default.createElement(
        _radio2.default.Group,
        (0, _extends3.default)({
            disabled: props.disabled,
            name: props.name,
            onChange: function onChange(event) {
                return props.onChange(event.target.value);
            },
            value: props.value
        }, (0, _filterDOMProps2.default)(props)),
        props.allowedValues.map(function (value) {
            return _react2.default.createElement(
                _radio2.default,
                {
                    key: value,
                    value: value,
                    style: {
                        display: 'block',
                        height: '30px',
                        lineHeight: '30px'
                    }
                },
                props.transform ? props.transform(value) : value
            );
        })
    );
};

var renderSelect = function renderSelect(props) {
    return _react2.default.createElement(
        _select2.default,
        (0, _extends3.default)({
            allowClear: !props.required,
            disabled: props.disabled,
            id: props.id,
            mode: props.fieldType === Array ? 'multiple' : undefined,
            name: props.name,
            onChange: function onChange(value) {
                return props.onChange(value);
            },
            placeholder: props.placeholder,
            ref: props.inputRef,
            value: props.fieldType === Array ? props.value || [] : '' + (props.value || '')
        }, (0, _filterDOMProps2.default)(props)),
        props.allowedValues.map(function (value) {
            return _react2.default.createElement(
                _select2.default.Option,
                { key: value, value: value },
                props.transform ? props.transform(value) : value
            );
        })
    );
};

var Select_ = function Select_(props) {
    return (0, _wrapField2.default)(props, props.checkboxes ? renderCheckboxes(props) : renderSelect(props));
};

Select_.displayName = 'Select';

exports.default = (0, _connectField2.default)(Select_);


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-antd/SelectField.js
// module id = 631
// module chunks = 35783957827783 65974612472484